export const ADD_EXCEPTION = 'addException'
export const ADD_EXCEPTIONS = 'addExceptions'
export const CLEAR_EXCEPTIONS = 'clearExceptions'
export const CLEAR_EXCEPTION_BY_SOURCE_PARAMETER = 'clearExceptionBySourceParameter'
